import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

// Static Intuit "Disconnect URL" landing page (QuickBooks tech requirement 5.3).
export default function QuickBooksDisconnectedPage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="qbo-disconnected-page">
      <div className="max-w-md w-full text-left">
        <img src="/images/integrations/quickbooks-mark.png" alt="QuickBooks" className="w-12 h-12 mb-6" />
        <h1 className="text-2xl font-semibold text-gray-900 tracking-tight">
          QuickBooks is disconnected
        </h1>
        <p className="mt-3 text-sm text-gray-500 leading-relaxed">
          The connection between BookingFlows and your QuickBooks Online company has been
          terminated. Your synced Purchases and Sales Receipts stay safely in QuickBooks —
          we just can&apos;t post new ones until you reconnect.
        </p>

        <div className="mt-6 rounded-xl bg-gray-50 p-5">
          <p className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-3">How to reconnect</p>
          <ol className="space-y-2.5 text-sm text-gray-600">
            <li className="flex gap-2.5"><CheckCircle2 className="w-4 h-4 text-[#2CA01C] shrink-0 mt-0.5" />Log in to your BookingFlows dashboard</li>
            <li className="flex gap-2.5"><CheckCircle2 className="w-4 h-4 text-[#2CA01C] shrink-0 mt-0.5" />Go to Marketing → Integrations</li>
            <li className="flex gap-2.5"><CheckCircle2 className="w-4 h-4 text-[#2CA01C] shrink-0 mt-0.5" />Select Connect to QuickBooks and authorize your company</li>
          </ol>
        </div>

        <Link
          to="/login"
          data-testid="qbo-disconnected-login-link"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Log in to BookingFlows <ArrowRight className="w-4 h-4" />
        </Link>

        <p className="mt-8 text-[10px] text-gray-400">
          Intuit and QuickBooks are registered trademarks of Intuit Inc. Used with permission.
        </p>
      </div>
    </div>
  );
}
